import { component } from 'vue-form-generator';
// import 'vue-form-generator/dist/vfg.css';

import customObjectData from '@/data/custom-object-schema';
import AppItemCreate from '@/components/app-item-create/app-item-create.vue';

export default {
  name: 'CustomObject',

  components: {
    AppItemCreate,
    VueFormGenerator: component,
  },

  data() {
    return {
      customObject: {
        model: customObjectData.model,
        schema: customObjectData.schema,
        formOptions: customObjectData.formOptions,
      },
      permissions: {
        model: customObjectData.permissions.model,
        schema: customObjectData.permissions.schema,
        formOptions: customObjectData.permissions.formOptions,
      },
      fields: {
        model: customObjectData.newField.model,
        schema: customObjectData.newField.schema,
        formOptions: customObjectData.newField.formOptions,
      },
      newRelationship: {
        model: customObjectData.newRelationship.model,
        schema: customObjectData.newRelationship.schema,
        formOptions: customObjectData.newRelationship.formOptions,
      },
    };
  },

  methods: {
    createNewObject() {
      this.$router.push({ name: 'edit-custom-object' });
    },
  },
};
